import createPersistedState from "vuex-persistedstate";
import { createStore } from "vuex";
import { auth } from "./auth-module";

const store = createStore({
  modules: {
    auth,
  },
  plugins: [createPersistedState()],
});

export default store;
